import React from "react";
import { NavLink } from "react-router-dom";

export const SettingsMenu = () => {
  return (
    <div className="aui-sidenav">
      <nav className="navbar-expand-lg overflow-hidden">
        <button
          className="navbar-toggler float-right m-3"
          type="button"
          data-toggle="collapse"
          data-target="#sideNavbar"
          aria-controls="sideNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="aha-icon-hamburger-round" />
        </button>
        <div className="collapse navbar-collapse" id="sideNavbar">
          <ul className="w-100 p-0 ul-list">
            <li>
              <NavLink
                exact
                to="/settings"
                className="nav-sidebar"
                activeClassName="nav-sidebar-active"
              >
                Invoice Configuration
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default SettingsMenu;
